import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'production' ? '/api' : `http://${location.hostname}:5000/api`

export default axios.create({
  baseURL,
  timeout: 30000
})
